import { ColumnHelper } from '@tanstack/react-table';

import { Checkbox } from '@/shared/components/checkbox';

const createSelectColumn = <TData,>(columnHelper: ColumnHelper<TData>) =>
  columnHelper.display({
    id: 'select-column',
    header: ({ table }) => (
      <Checkbox
        id='select-all-rows-per-page'
        checked={table.getIsAllPageRowsSelected()}
        indeterminate={table.getIsSomePageRowsSelected()}
        onChange={table.getToggleAllPageRowsSelectedHandler()}
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        id={`select-row-${row.id}`}
        checked={row.getIsSelected()}
        disabled={!row.getCanSelect()}
        onChange={row.getToggleSelectedHandler()}
      />
    ),
    size: 70,
  });

export default createSelectColumn;
